import axios from "axios";

const API_URL = import.meta.env.VITE_APP_API_URL;

export const fetchSchemeEntriesForReport = async (params?: {
	scheme_id?: string;
	district_id?: string;
	limit?: number;
}): Promise<{ items: any[]; totalItems: number }> => {
	const response = await axios.get(`${API_URL}/admin/scheme-data-entry/list`, {
		params: {
			limit: params?.limit || 500,
			scheme_id: params?.scheme_id || undefined,
			district_id: params?.district_id || undefined,
		},
	});
	const data = response.data.data || response.data;
	return Array.isArray(data) ? { items: data, totalItems: data.length } : data;
};
